"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _moment = _interopRequireDefault(require("moment"));
var _classnames = _interopRequireDefault(require("classnames"));
var _moment2 = _interopRequireDefault(require("rc-picker/lib/generate/moment"));
var _usePickerInput5 = _interopRequireDefault(require("rc-picker/lib/hooks/usePickerInput"));
var _useRangeDisabled3 = _interopRequireDefault(require("rc-picker/lib/hooks/useRangeDisabled"));
var _useRangeViewDates3 = _interopRequireDefault(require("rc-picker/lib/hooks/useRangeViewDates"));
var _useTextValueMapping5 = _interopRequireDefault(require("rc-picker/lib/hooks/useTextValueMapping"));
var _useValueTexts5 = _interopRequireDefault(require("rc-picker/lib/hooks/useValueTexts"));
var _PanelContext = _interopRequireDefault(require("rc-picker/lib/PanelContext"));
var _PickerPanel = _interopRequireDefault(require("rc-picker/lib/PickerPanel"));
var _PickerTrigger = _interopRequireDefault(require("rc-picker/lib/PickerTrigger"));
var _RangeContext = _interopRequireDefault(require("rc-picker/lib/RangeContext"));
var _dateUtil = require("rc-picker/lib/utils/dateUtil");
var _getExtraFooter = _interopRequireDefault(require("rc-picker/lib/utils/getExtraFooter"));
var _getRanges = _interopRequireDefault(require("rc-picker/lib/utils/getRanges"));
var _miscUtil = _interopRequireWildcard(require("rc-picker/lib/utils/miscUtil"));
var _uiUtil = require("rc-picker/lib/utils/uiUtil");
var _useMergedState11 = _interopRequireDefault(require("rc-util/lib/hooks/useMergedState"));
var _warning = _interopRequireDefault(require("rc-util/lib/warning"));
var _KeyCode = _interopRequireDefault(require("rc-util/lib/KeyCode"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _ykbUtils = require("ykb-utils");
var _ = require(".");
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledDatePicker = require("./StyledDatePicker");
var _ModalContext = require("../Modal/context/ModalContext");
var _excluded = ["prefixCls", "id", "style", "className", "popupStyle", "dropdownClassName", "transitionName", "dropdownAlign", "getPopupContainer", "generateConfig", "locale", "placeholder", "autoFocus", "disabled", "format", "picker", "showTime", "use12Hours", "separator", "value", "defaultValue", "defaultPickerValue", "open", "defaultOpen", "disabledDate", "disabledTime", "dateRender", "ranges", "allowEmpty", "allowClear", "suffixIcon", "clearIcon", "pickerRef", "inputReadOnly", "mode", "renderExtraFooter", "onChange", "onOpenChange", "onPanelChange", "onCalendarChange", "onFocus", "onBlur", "onOk", "components", "order", "direction", "activePickerIndex", "autoComplete", "allowInputChange", "showSecond", "size", "type", "keepValuesOnBlur"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function reorderValues(values, generateConfig) {
  if (values && values[0] && values[1] && generateConfig.isAfter(values[0], values[1])) {
    return [values[1], values[0]];
  }
  return values;
}
function canValueTrigger(value, index, disabled, allowEmpty) {
  if (value) {
    return true;
  }
  if (allowEmpty && allowEmpty[index]) {
    return true;
  }
  if (disabled[(index + 1) % 2]) {
    return true;
  }
  return false;
}
var RangePicker = function RangePicker(InputComponent) {
  return function (props) {
    var prefixCls = props.prefixCls,
      id = props.id,
      style = props.style,
      className = props.className,
      popupStyle = props.popupStyle,
      dropdownClassName = props.dropdownClassName,
      transitionName = props.transitionName,
      dropdownAlign = props.dropdownAlign,
      _props$getPopupContai = props.getPopupContainer,
      getPopupContainer = _props$getPopupContai === void 0 ? _ykbUtils.containerChecker : _props$getPopupContai,
      _props$generateConfig = props.generateConfig,
      generateConfig = _props$generateConfig === void 0 ? _moment2.default : _props$generateConfig,
      locale = props.locale,
      placeholder = props.placeholder,
      autoFocus = props.autoFocus,
      disabled = props.disabled,
      format = props.format,
      _props$picker = props.picker,
      picker = _props$picker === void 0 ? 'date' : _props$picker,
      showTime = props.showTime,
      use12Hours = props.use12Hours,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '~' : _props$separator,
      value = props.value,
      defaultValue = props.defaultValue,
      defaultPickerValue = props.defaultPickerValue,
      openByProps = props.open,
      defaultOpen = props.defaultOpen,
      _disabledDate = props.disabledDate,
      _disabledTime = props.disabledTime,
      dateRender = props.dateRender,
      ranges = props.ranges,
      allowEmpty = props.allowEmpty,
      allowClear = props.allowClear,
      suffixIcon = props.suffixIcon,
      clearIcon = props.clearIcon,
      pickerRef = props.pickerRef,
      inputReadOnly = props.inputReadOnly,
      mode = props.mode,
      renderExtraFooter = props.renderExtraFooter,
      onChange = props.onChange,
      onOpenChange = props.onOpenChange,
      onPanelChange = props.onPanelChange,
      onCalendarChange = props.onCalendarChange,
      _onFocus = props.onFocus,
      onBlur = props.onBlur,
      _onOk = props.onOk,
      components = props.components,
      order = props.order,
      direction = props.direction,
      activePickerIndex = props.activePickerIndex,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete,
      _props$allowInputChan = props.allowInputChange,
      allowInputChange = _props$allowInputChan === void 0 ? true : _props$allowInputChan,
      _props$showSecond = props.showSecond,
      showSecond = _props$showSecond === void 0 ? true : _props$showSecond,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      type = props.type,
      _props$keepValuesOnBl = props.keepValuesOnBlur,
      keepValuesOnBlur = _props$keepValuesOnBl === void 0 ? false : _props$keepValuesOnBl,
      restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
    var _useState = (0, _react.useState)(openByProps || defaultOpen || false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];
    (0, _react.useEffect)(function () {
      if (openByProps !== null && openByProps !== undefined && typeof openByProps === 'boolean') {
        setOpen(openByProps);
      }
    }, [openByProps]);
    var needConfirmButton = picker === 'date' && !!showTime || picker === 'time';

    // We record opened status here in case repeat open with picker
    var openRecordsRef = (0, _react.useRef)({});
    var containerRef = (0, _react.useRef)(null);
    var panelDivRef = (0, _react.useRef)(null);
    var startInputDivRef = (0, _react.useRef)(null);
    var endInputDivRef = (0, _react.useRef)(null);
    var separatorRef = (0, _react.useRef)(null);
    var startInputRef = (0, _react.useRef)(null);
    var endInputRef = (0, _react.useRef)(null);

    // ============================= Misc ==============================
    var formatList = (0, _miscUtil.toArray)((0, _uiUtil.getDefaultFormat)(format, picker, showTime, use12Hours));

    // Active picker
    var _useMergedState = (0, _useMergedState11.default)(0, {
        value: activePickerIndex
      }),
      _useMergedState2 = (0, _slicedToArray2.default)(_useMergedState, 2),
      mergedActivePickerIndex = _useMergedState2[0],
      setMergedActivePickerIndex = _useMergedState2[1];

    // Operation ref
    var operationRef = (0, _react.useRef)(null);
    var mergedDisabled = React.useMemo(function () {
      if (Array.isArray(disabled)) {
        return disabled;
      }
      return [disabled || false, disabled || false];
    }, [disabled]);

    // ============================= Value =============================
    var _useMergedState3 = (0, _useMergedState11.default)(null, {
        value: value,
        defaultValue: defaultValue,
        postState: function postState(values) {
          return picker === 'time' && !order ? values : reorderValues(values, generateConfig);
        }
      }),
      _useMergedState4 = (0, _slicedToArray2.default)(_useMergedState3, 2),
      mergedValue = _useMergedState4[0],
      setInnerValue = _useMergedState4[1];

    // =========================== View Date ===========================
    // Config view panel
    var _useRangeViewDates = (0, _useRangeViewDates3.default)({
        values: mergedValue,
        picker: picker,
        defaultDates: defaultPickerValue,
        generateConfig: generateConfig
      }),
      _useRangeViewDates2 = (0, _slicedToArray2.default)(_useRangeViewDates, 2),
      getViewDate = _useRangeViewDates2[0],
      setViewDate = _useRangeViewDates2[1];

    // ========================= Select Values =========================
    var _useMergedState5 = (0, _useMergedState11.default)(mergedValue, {
        postState: function postState(values) {
          var postValues = values;
          if (mergedDisabled[0] && mergedDisabled[1]) {
            return postValues;
          }

          // Fill disabled unit
          for (var i = 0; i < 2; i += 1) {
            if (mergedDisabled[i] && !(0, _miscUtil.getValue)(postValues, i) && !(0, _miscUtil.getValue)(allowEmpty, i)) {
              postValues = (0, _miscUtil.updateValues)(postValues, generateConfig.getNow(), i);
            }
          }
          return postValues;
        }
      }),
      _useMergedState6 = (0, _slicedToArray2.default)(_useMergedState5, 2),
      selectedValue = _useMergedState6[0],
      setSelectedValue = _useMergedState6[1];
    var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      rangeHoverValue = _useState4[0],
      setRangeHoverValue = _useState4[1];

    // ========================== Hover Range ==========================
    var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hoverRangedValue = _useState6[0],
      setHoverRangedValue = _useState6[1];
    var onDateMouseEnter = function onDateMouseEnter(date) {
      setHoverRangedValue((0, _miscUtil.updateValues)(selectedValue, date, mergedActivePickerIndex));
    };
    var onDateMouseLeave = function onDateMouseLeave() {
      setHoverRangedValue((0, _miscUtil.updateValues)(selectedValue, null, mergedActivePickerIndex));
    };

    // ============================= Modes =============================
    var _useMergedState7 = (0, _useMergedState11.default)([picker, picker], {
        value: mode
      }),
      _useMergedState8 = (0, _slicedToArray2.default)(_useMergedState7, 2),
      mergedModes = _useMergedState8[0],
      setInnerModes = _useMergedState8[1];
    (0, _react.useEffect)(function () {
      setInnerModes([picker, picker]);
    }, [picker]);
    React.useEffect(function () {
      if (Array.isArray(value)) {
        var values = [];
        if (value[0] instanceof _moment.default && (0, _moment.default)().isValid(value[0])) {
          // set valid moment value to startDate
          values[0] = value[0];
        }
        if (value[1] instanceof _moment.default && (0, _moment.default)().isValid(value[1])) {
          // set valid moment value to endDate
          values[1] = value[1];
        }
        triggerChange(values, null);
      }
    }, [value]);
    var triggerModesChange = function triggerModesChange(modes, values) {
      setInnerModes(modes);
      if (onPanelChange) {
        onPanelChange(values, modes);
      }
    };

    // ========================= Disable Date ==========================
    var _useRangeDisabled = (0, _useRangeDisabled3.default)({
        picker: picker,
        selectedValue: selectedValue,
        locale: locale,
        disabled: mergedDisabled,
        // disabledDate methoduna 2. parametre değeri gönderir,
        // ilk tarih seçimi yapıldıktan sonra bu tarihe göre disabled olma durumlarını güncellemek için eklendi.
        // örn: ilk seçilen tarihten sonra max 3 gün aralığında seçim yapılabilsin.
        disabledDate: function disabledDate(date) {
          return _disabledDate && _disabledDate(date, selectedValue);
        },
        generateConfig: generateConfig
      }, openRecordsRef.current[1], openRecordsRef.current[0]),
      _useRangeDisabled2 = (0, _slicedToArray2.default)(_useRangeDisabled, 2),
      disabledStartDate = _useRangeDisabled2[0],
      disabledEndDate = _useRangeDisabled2[1];

    // ============================= Open ==============================
    var _useMergedState9 = (0, _useMergedState11.default)(false, {
        value: open,
        defaultValue: defaultOpen,
        postState: function postState(postOpen) {
          return mergedDisabled[mergedActivePickerIndex] ? false : postOpen;
        },
        onChange: function onChange(newOpen) {
          if (onOpenChange) {
            onOpenChange(newOpen);
          }
          if (!newOpen && operationRef.current && operationRef.current.onClose) {
            operationRef.current.onClose();
          }
          setOpen(newOpen);
        }
      }),
      _useMergedState10 = (0, _slicedToArray2.default)(_useMergedState9, 2),
      mergedOpen = _useMergedState10[0],
      triggerInnerOpen = _useMergedState10[1];
    var startOpen = mergedOpen && mergedActivePickerIndex === 0;
    var endOpen = mergedOpen && mergedActivePickerIndex === 1;

    // ============================= Popup =============================
    // Popup min width
    var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      popupMinWidth = _useState8[0],
      setPopupMinWidth = _useState8[1];
    (0, _react.useEffect)(function () {
      if (!mergedOpen && containerRef.current) {
        setPopupMinWidth(containerRef.current.offsetWidth);
      }
    }, [mergedOpen]);

    // ============================ Trigger ============================
    var triggerRef = React.useRef();
    function _triggerOpen(newOpen, index) {
      if (newOpen) {
        clearTimeout(triggerRef.current);
        openRecordsRef.current = {
          0: index === 0,
          1: index === 1
        };
        setMergedActivePickerIndex(index);
        triggerInnerOpen(newOpen);

        // Open to reset view date
        if (!mergedOpen) {
          setViewDate(null, index);
        }
      } else if (mergedActivePickerIndex === index) {
        triggerInnerOpen(newOpen);

        // Clean up async
        // This makes ref not quick refresh in case user open another input with blur trigger
        var openRecords = openRecordsRef.current;
        triggerRef.current = setTimeout(function () {
          if (openRecords === openRecordsRef.current) {
            openRecordsRef.current = {};
          }
        });
      }
    }
    function triggerChange(newValue, sourceIndex) {
      var values = newValue;
      var startValue = (0, _miscUtil.getValue)(values, 0);
      var endValue = (0, _miscUtil.getValue)(values, 1);

      // >>>>> Format start & end values
      if (startValue && endValue && generateConfig.isAfter(startValue, endValue)) {
        if (
        // WeekPicker only compare week
        picker === 'week' && !(0, _dateUtil.isSameWeek)(generateConfig, locale.locale, startValue, endValue) ||
        // QuotaPicker only compare week
        picker === 'quarter' && !(0, _dateUtil.isSameQuarter)(generateConfig, startValue, endValue) ||
        // Other non-TimePicker compare date
        picker !== 'week' && picker !== 'quarter' && picker !== 'time' && !(0, _dateUtil.isSameDate)(generateConfig, startValue, endValue)) {
          // Clean up end date when start date is after end date
          values = [startValue, null];
          endValue = null;

          // Clean up cache since invalidate
          openRecordsRef.current = {};
        } else if (picker !== 'time' || order !== false) {
          // Reorder when in same date
          values = reorderValues(values, generateConfig);
        }
      }
      setSelectedValue(values);
      var startStr = values && values[0] ? generateConfig.locale.format(locale.locale, values[0], formatList[0]) : '';
      var endStr = values && values[1] ? generateConfig.locale.format(locale.locale, values[1], formatList[0]) : '';
      if (onCalendarChange) {
        onCalendarChange(values, [startStr, endStr]);
      }

      // >>>>> Trigger `onChange` event
      var canStartValueTrigger = canValueTrigger(startValue, 0, mergedDisabled, allowEmpty);
      var canEndValueTrigger = canValueTrigger(endValue, 1, mergedDisabled, allowEmpty);
      var canTrigger = values === null || canStartValueTrigger && canEndValueTrigger;
      if (canTrigger) {
        // Trigger onChange only when value is validate
        setInnerValue(values);
        if (onChange && (!(0, _dateUtil.isEqual)(generateConfig, (0, _miscUtil.getValue)(mergedValue, 0), startValue) || !(0, _dateUtil.isEqual)(generateConfig, (0, _miscUtil.getValue)(mergedValue, 1), endValue))) {
          onChange(values, [startStr, endStr]);
          endOpen && setOpen(false);
        }
      }

      // >>>>> Open picker when

      // Always open another picker if possible
      var nextOpenIndex = null;
      if (sourceIndex === 0 && !mergedDisabled[1]) {
        nextOpenIndex = 1;
      } else if (sourceIndex === 1 && !mergedDisabled[0]) {
        nextOpenIndex = 0;
      }
      if (nextOpenIndex !== null && nextOpenIndex !== mergedActivePickerIndex && !openRecordsRef.current[nextOpenIndex] && (0, _miscUtil.getValue)(values, sourceIndex)) {
        _triggerOpen(true, nextOpenIndex);

        // Delay to focus to avoid input blur trigger expired selectedValues
        setTimeout(function () {
          var inputRef = [startInputRef, endInputRef][nextOpenIndex];
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0);
      } else {
        _triggerOpen(false, sourceIndex);
      }
    }
    var forwardKeyDown = function forwardKeyDown(e) {
      if (mergedOpen && operationRef.current && operationRef.current.onKeyDown) {
        // Let popup panel handle keyboard
        return operationRef.current.onKeyDown(e);
      }

      /* istanbul ignore next */
      /* eslint-disable no-lone-blocks */
      {
        (0, _warning.default)(false, 'Picker not correct forward KeyDown operation. Please help to fire issue about this.');
        return false;
      }
    };

    // ============================= Text ==============================
    var sharedTextHooksProps = {
      formatList: formatList,
      generateConfig: generateConfig,
      locale: locale
    };
    var _useValueTexts = (0, _useValueTexts5.default)((0, _miscUtil.getValue)(selectedValue, 0), sharedTextHooksProps),
      _useValueTexts2 = (0, _slicedToArray2.default)(_useValueTexts, 2),
      startValueTexts = _useValueTexts2[0],
      firstStartValueText = _useValueTexts2[1];
    var _useValueTexts3 = (0, _useValueTexts5.default)((0, _miscUtil.getValue)(selectedValue, 1), sharedTextHooksProps),
      _useValueTexts4 = (0, _slicedToArray2.default)(_useValueTexts3, 2),
      endValueTexts = _useValueTexts4[0],
      firstEndValueText = _useValueTexts4[1];
    var _onTextChange = function onTextChange(newText, index) {
      var inputDate = generateConfig.locale.parse(locale.locale, newText, formatList);
      var disabledFunc = index === 0 ? disabledStartDate : disabledEndDate;
      if (inputDate && !disabledFunc(inputDate)) {
        setSelectedValue((0, _miscUtil.updateValues)(selectedValue, inputDate, index));
        setViewDate(inputDate, index);
      }
    };
    var _useTextValueMapping = (0, _useTextValueMapping5.default)({
        valueTexts: startValueTexts,
        onTextChange: function onTextChange(newText) {
          return _onTextChange(newText, 0);
        }
      }),
      _useTextValueMapping2 = (0, _slicedToArray2.default)(_useTextValueMapping, 3),
      startText = _useTextValueMapping2[0],
      triggerStartTextChange = _useTextValueMapping2[1],
      resetStartText = _useTextValueMapping2[2];
    var _useTextValueMapping3 = (0, _useTextValueMapping5.default)({
        valueTexts: endValueTexts,
        onTextChange: function onTextChange(newText) {
          return _onTextChange(newText, 1);
        }
      }),
      _useTextValueMapping4 = (0, _slicedToArray2.default)(_useTextValueMapping3, 3),
      endText = _useTextValueMapping4[0],
      triggerEndTextChange = _useTextValueMapping4[1],
      resetEndText = _useTextValueMapping4[2];

    // ============================= Input =============================
    var getSharedInputHookProps = function getSharedInputHookProps(index, resetText) {
      return {
        blurToCancel: needConfirmButton,
        forwardKeyDown: forwardKeyDown,
        onBlur: onBlur,
        isClickOutside: function isClickOutside(target) {
          return !(0, _uiUtil.elementsContains)([panelDivRef.current, startInputDivRef.current, endInputDivRef.current], target);
        },
        onFocus: function onFocus(e) {
          setMergedActivePickerIndex(index);
          if (_onFocus) {
            _onFocus(e);
          }
        },
        triggerOpen: function triggerOpen(newOpen) {
          _triggerOpen(newOpen, index);
        },
        onSubmit: function onSubmit() {
          triggerChange(selectedValue, index);
          resetText();
        },
        onCancel: function onCancel() {
          _triggerOpen(false, index);
          setSelectedValue(mergedValue);
          resetText();
        }
      };
    };
    var _usePickerInput = (0, _usePickerInput5.default)(_objectSpread(_objectSpread({}, getSharedInputHookProps(0, resetStartText)), {}, {
        open: startOpen,
        value: startText,
        onKeyDown: startInputKeyDown
      })),
      _usePickerInput2 = (0, _slicedToArray2.default)(_usePickerInput, 2),
      startInputProps = _usePickerInput2[0],
      _usePickerInput2$ = _usePickerInput2[1],
      startFocused = _usePickerInput2$.focused,
      startTyping = _usePickerInput2$.typing;
    var _usePickerInput3 = (0, _usePickerInput5.default)(_objectSpread(_objectSpread({}, getSharedInputHookProps(1, resetEndText)), {}, {
        open: endOpen,
        value: endText,
        onKeyDown: endInputKeyDown
      })),
      _usePickerInput4 = (0, _slicedToArray2.default)(_usePickerInput3, 2),
      endInputProps = _usePickerInput4[0],
      _usePickerInput4$ = _usePickerInput4[1],
      endFocused = _usePickerInput4$.focused,
      endTyping = _usePickerInput4$.typing;

    // ============================= Sync ==============================
    // Close should sync back with text value
    var startStr = mergedValue && mergedValue[0] ? generateConfig.locale.format(locale.locale, mergedValue[0], 'YYYYMMDDHHmmss') : '';
    var endStr = mergedValue && mergedValue[1] ? generateConfig.locale.format(locale.locale, mergedValue[1], 'YYYYMMDDHHmmss') : '';
    (0, _react.useEffect)(function () {
      if (!mergedOpen) {
        keepValuesOnBlur ? !!mergedValue && setSelectedValue(mergedValue) : setSelectedValue(mergedValue);
        if (!startValueTexts.length || startValueTexts[0] === '') {
          triggerStartTextChange('');
        } else if (firstStartValueText !== startText) {
          resetStartText();
        }
        if (!endValueTexts.length || endValueTexts[0] === '') {
          triggerEndTextChange('');
        } else if (firstEndValueText !== endText) {
          resetEndText();
        }
      }
    }, [mergedOpen, startValueTexts, endValueTexts]);

    // Sync innerValue with control mode
    (0, _react.useEffect)(function () {
      setSelectedValue(mergedValue);
    }, [startStr, endStr]);

    // ============================ Warning ============================
    if (process.env.NODE_ENV !== 'production') {
      if (value && Array.isArray(disabled) && ((0, _miscUtil.getValue)(disabled, 0) && !(0, _miscUtil.getValue)(value, 0) || (0, _miscUtil.getValue)(disabled, 1) && !(0, _miscUtil.getValue)(value, 1))) {
        (0, _warning.default)(false, '`disabled` should not set with empty `value`. You should set `allowEmpty` or `value` instead.');
      }
    }

    // ============================ Private ============================
    if (pickerRef) {
      pickerRef.current = {
        focus: function focus() {
          if (startInputRef.current) {
            startInputRef.current.focus();
          }
        },
        blur: function blur() {
          if (startInputRef.current) {
            startInputRef.current.blur();
          }
          if (endInputRef.current) {
            endInputRef.current.blur();
          }
        }
      };
    }

    // ============================ Format =============================

    var getFormat = function getFormat() {
      if (format) return format;
      if (picker == 'time') {
        return showSecond ? _.formats.timeFormat : _.formats.timeFormatWithoutSeconds;
      } else if (picker == 'month') {
        return _.formats.dateFormat;
      } else if (picker == 'week') {
        return _.formats.weekFormat;
      } else if (picker == 'year') {
        return _.formats.yearFormat;
      }
      return showTime ? _.formats.dateTimeFormat : _.formats.dateFormat;
    };
    var getControlCharLength = function getControlCharLength(format) {
      if (format) return format.length;
      if (picker == 'time') {
        return showSecond ? _.formats.timeFormat.length : _.formats.timeFormatWithoutSeconds.length;
      } else if (picker == 'month') {
        return _.formats.monthFormat.length;
      } else if (picker == 'week') {
        return _.formats.weekFormat.length;
      } else if (picker == 'year') {
        return _.formats.yearFormat.length;
      }
      return showTime ? _.formats.dateTimeFormat.length : _.formats.dateFormat.length;
    };

    // ============================ Ranges =============================
    var rangeLabels = Object.keys(ranges || {});
    var rangeList = rangeLabels.map(function (label) {
      var range = ranges[label];
      var newValues = typeof range === 'function' ? range() : range;
      return {
        label: label,
        onClick: function onClick() {
          // triggerChangeOld(newValues);
          triggerChange(newValues, null);
        },
        onMouseEnter: function onMouseEnter() {
          setRangeHoverValue(newValues);
        },
        onMouseLeave: function onMouseLeave() {
          setRangeHoverValue(null);
        }
      };
    });

    // ============================= Panel =============================
    function renderPanel() {
      var panelPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var panelProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var showDoublePanel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var panelHoverRangedValue = null;
      if (mergedOpen && hoverRangedValue && hoverRangedValue[0] && hoverRangedValue[1] && generateConfig.isAfter(hoverRangedValue[1], hoverRangedValue[0])) {
        panelHoverRangedValue = hoverRangedValue;
      }
      var panelShowTime = showTime;
      if (showTime && (0, _typeof2.default)(showTime) === 'object' && showTime.defaultValue) {
        var timeDefaultValues = showTime.defaultValue;
        panelShowTime = _objectSpread(_objectSpread({}, showTime), {}, {
          defaultValue: (0, _miscUtil.getValue)(timeDefaultValues, mergedActivePickerIndex) || undefined
        });
      }
      var panelDateRender = null;
      if (dateRender) {
        panelDateRender = function panelDateRender(date, today) {
          return dateRender(date, today, {
            range: mergedActivePickerIndex ? 'end' : 'start'
          });
        };
      }
      return /*#__PURE__*/React.createElement(_RangeContext.default.Provider, {
        value: {
          inRange: true,
          panelPosition: panelPosition,
          rangedValue: rangeHoverValue || selectedValue,
          hoverRangedValue: panelHoverRangedValue
        }
      }, /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_StyledDatePicker.StyledPickerPanelWrapper, {
          theme: theme,
          $panelPosition: panelPosition,
          $showDoublePanel: showDoublePanel,
          prefixCls: prefixCls
        }, function (styledPrefix) {
          return /*#__PURE__*/React.createElement(_PickerPanel.default, (0, _extends2.default)({}, props, panelProps, {
            prevIcon: /*#__PURE__*/React.createElement(_Icon.default, {
              name: "angle-left"
            }),
            nextIcon: /*#__PURE__*/React.createElement(_Icon.default, {
              name: "angle-right"
            }),
            superPrevIcon: /*#__PURE__*/React.createElement(_Icon.default, {
              name: "angle-double-left"
            }),
            superNextIcon: /*#__PURE__*/React.createElement(_Icon.default, {
              name: "angle-double-right"
            }),
            dateRender: panelDateRender,
            showTime: panelShowTime,
            mode: mergedModes[mergedActivePickerIndex],
            generateConfig: generateConfig,
            style: undefined,
            direction: direction,
            disabledDate: mergedActivePickerIndex === 0 ? disabledStartDate : disabledEndDate,
            disabledTime: function disabledTime(date) {
              if (_disabledTime) {
                return _disabledTime(date, mergedActivePickerIndex === 0 ? 'start' : 'end');
              }
              return false;
            },
            prefixCls: styledPrefix,
            className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-panel-focused"), !!prefixCls && mergedActivePickerIndex === 0 ? !startTyping : !endTyping)),
            value: (0, _miscUtil.getValue)(selectedValue, mergedActivePickerIndex),
            locale: locale,
            tabIndex: -1,
            onPanelChange: function onPanelChange(date, newMode) {
              triggerModesChange((0, _miscUtil.updateValues)(mergedModes, newMode, mergedActivePickerIndex), (0, _miscUtil.updateValues)(selectedValue, date, mergedActivePickerIndex));
              var viewDate = date;
              if (panelPosition === 'right') {
                viewDate = (0, _dateUtil.getClosingViewDate)(viewDate, newMode, generateConfig, -1);
              }
              setViewDate(viewDate, mergedActivePickerIndex);
            },
            onOk: null,
            onSelect: undefined,
            onChange: undefined,
            defaultValue: undefined,
            defaultPickerValue: undefined
          }));
        });
      }));
    }
    var arrowLeft = 0;
    var panelLeft = 0;
    if (mergedActivePickerIndex && startInputDivRef.current && separatorRef.current && panelDivRef.current) {
      // Arrow offset
      arrowLeft = startInputDivRef.current.offsetWidth + separatorRef.current.offsetWidth;
      if (panelDivRef.current.offsetWidth && arrowLeft > panelDivRef.current.offsetWidth) {
        panelLeft = arrowLeft;
      }
    }
    var arrowPositionStyle = direction === 'rtl' ? {
      right: arrowLeft
    } : {
      left: arrowLeft
    };
    var startInputDisplayValue = selectedValue && selectedValue[0] && selectedValue[0].format(getFormat(showTime)) || '';
    var endInputDisplayValue = selectedValue && selectedValue[1] && selectedValue[1].format(getFormat(showTime)) || '';
    function renderPanels(theme, styledPrefixCls) {
      var panels;
      var extraNode = (0, _getExtraFooter.default)(styledPrefixCls, mergedModes[mergedActivePickerIndex], renderExtraFooter);
      var rangesNode = (0, _getRanges.default)({
        prefixCls: styledPrefixCls,
        components: components,
        needConfirmButton: needConfirmButton,
        okDisabled: !(0, _miscUtil.getValue)(selectedValue, mergedActivePickerIndex),
        locale: locale,
        rangeList: rangeList,
        onOk: function onOk() {
          if ((0, _miscUtil.getValue)(selectedValue, mergedActivePickerIndex)) {
            // triggerChangeOld(selectedValue);
            triggerChange(selectedValue, mergedActivePickerIndex);
            if (_onOk) {
              _onOk(selectedValue);
            }
          }
        }
      });
      if (picker !== 'time' && !showTime) {
        var viewDate = getViewDate(mergedActivePickerIndex);
        var nextViewDate = (0, _dateUtil.getClosingViewDate)(viewDate, picker, generateConfig);
        var currentMode = mergedModes[mergedActivePickerIndex];
        var showDoublePanel = currentMode === picker;
        var leftPanel = renderPanel(showDoublePanel ? 'left' : false, {
          pickerValue: viewDate,
          onPickerValueChange: function onPickerValueChange(newViewDate) {
            setViewDate(newViewDate, mergedActivePickerIndex);
          },
          showDoublePanel: showDoublePanel
        });
        var rightPanel = renderPanel('right', {
          pickerValue: nextViewDate,
          onPickerValueChange: function onPickerValueChange(newViewDate) {
            setViewDate((0, _dateUtil.getClosingViewDate)(newViewDate, picker, generateConfig, -1), mergedActivePickerIndex);
          },
          showDoublePanel: showDoublePanel
        });
        if (direction === 'rtl') {
          panels = /*#__PURE__*/React.createElement(React.Fragment, null, rightPanel, showDoublePanel && leftPanel);
        } else {
          panels = /*#__PURE__*/React.createElement(React.Fragment, null, leftPanel, showDoublePanel && rightPanel);
        }
      } else {
        panels = renderPanel();
      }
      return /*#__PURE__*/React.createElement(_StyledDatePicker.StyledPickerPanelContainer, {
        theme: theme,
        style: {
          marginLeft: panelLeft
        },
        ref: panelDivRef,
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
        },
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-panel-container"), !!prefixCls))
      }, /*#__PURE__*/React.createElement(_StyledDatePicker.StyledPickerPanels, {
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-panels"), !!prefixCls)),
        theme: theme
      }, panels), (extraNode || rangesNode) &&
      /*#__PURE__*/
      //TODO
      React.createElement("div", {
        className: "".concat(styledPrefixCls, "-footer")
      }, extraNode, rangesNode));
    }
    var rangePanel = function rangePanel(styledPrefix) {
      return /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/React.createElement(_StyledDatePicker.StyledRangePickerWrapper, {
          theme: theme,
          style: {
            minWidth: popupMinWidth
          },
          className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-range-wrapper"), !!prefixCls), "".concat(prefixCls, "-").concat(picker, "-range-wrapper"), !!prefixCls))
        }, /*#__PURE__*/React.createElement(_StyledDatePicker.StyledRangePickerRangeArrow, {
          theme: theme,
          style: arrowPositionStyle,
          className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-range-arrow"), !!prefixCls))
        }), renderPanels(theme, styledPrefix));
      });
    };
    var activeBarLeft = 10;
    var activeBarWidth = 0;
    if (startInputDivRef.current && endInputDivRef.current && separatorRef.current) {
      if (mergedActivePickerIndex === 0) {
        activeBarWidth = startInputDivRef.current.offsetWidth - 10;
      } else {
        activeBarLeft = arrowLeft + 16;
        activeBarWidth = endInputDivRef.current.offsetWidth - 36;
      }
    }
    var activeBarPositionStyle = direction === 'rtl' ? {
      right: activeBarLeft
    } : {
      left: activeBarLeft
    };
    // ============================ Return =============================
    var onContextSelect = function onContextSelect(date, type) {
      var values = (0, _miscUtil.updateValues)(selectedValue, date, mergedActivePickerIndex);
      if (type === 'submit' || type !== 'key' && !needConfirmButton) {
        // triggerChange will also update selected values
        // triggerChangeOld(values);
        triggerChange(values, mergedActivePickerIndex);
      } else {
        setSelectedValue(values);
      }
    };
    var startDateInputChange = function startDateInputChange(event, unmaskedValue, maskedValue) {
      if (!allowInputChange) {
        return;
      }
      // let controlCharLength = showTime ? dateTimeFormat.length : dateFormat.length;

      if (unmaskedValue.length === getControlCharLength(format)) {
        if (picker == 'month') {
          unmaskedValue = "21/".concat(unmaskedValue.split('-').reverse().join('/'));
        } else if (picker == 'week') {
          var weekNumber = Number(unmaskedValue.split('-')[1]);
          if (weekNumber == 1) {
            unmaskedValue = (0, _moment.default)().startOf('year');
          } else {
            unmaskedValue = (0, _moment.default)().day('Monday').week(weekNumber);
          }
        } else if (picker == 'year') {
          unmaskedValue = (0, _moment.default)().day('Monday').year(unmaskedValue);
        }
        var momentValue = (0, _moment.default)(unmaskedValue, getFormat(showTime), true);
        if (momentValue.isValid()) {
          //if (this.controlDisable(momentValue)) this.handleChange(null);
          //else this.handleChange(momentValue);
          var values = (0, _miscUtil.updateValues)(selectedValue, momentValue, 0);
          triggerChange(values, null);
        } else {
          triggerChange(null);
        }
      }
    };
    var endDateInputChange = function endDateInputChange(event, unmaskedValue, maskedValue) {
      if (!allowInputChange) {
        return;
      }
      // let controlCharLength = showTime ? dateTimeFormat.length : dateFormat.length;

      if (unmaskedValue.length === getControlCharLength(format)) {
        if (picker == 'month') {
          unmaskedValue = "21/".concat(unmaskedValue.split('-').reverse().join('/'));
        } else if (picker == 'week') {
          var weekNumber = Number(unmaskedValue.split('-')[1]);
          if (weekNumber == 1) {
            unmaskedValue = (0, _moment.default)().startOf('year');
          } else {
            unmaskedValue = (0, _moment.default)().day('Monday').week(weekNumber);
          }
        } else if (picker == 'year') {
          unmaskedValue = (0, _moment.default)().day('Monday').year(unmaskedValue);
        }
        var momentValue = (0, _moment.default)(unmaskedValue, getFormat(showTime), true);
        if (momentValue.isValid()) {
          //if (this.controlDisable(momentValue)) this.handleChange(null);
          //else this.handleChange(momentValue);
          var values = (0, _miscUtil.updateValues)(selectedValue, momentValue, 1);
          triggerChange(values, null);
        } else {
          triggerChange(null);
        }
      }
    };
    var onClearClicked = function onClearClicked() {
      var values = mergedValue;
      if (!mergedDisabled[0]) {
        values = (0, _miscUtil.updateValues)(values, null, 0);
      }
      if (!mergedDisabled[1]) {
        values = (0, _miscUtil.updateValues)(values, null, 1);
      }
      triggerChange(values, null);
    };
    function startInputKeyDown(e) {
      if (e.which == _KeyCode.default.ENTER) {
        e.stopPropagation();
      }
    }
    function endInputKeyDown(e) {
      if (e.which == _KeyCode.default.ENTER) {
        e.stopPropagation();
      }
    }
    function isTimePicker() {
      if (picker === 'time') {
        return true;
      } else {
        false;
      }
    }
    var getPlaceholder = function getPlaceholder() {
      var _placeholder$startTim, _placeholder$startDat, _placeholder$endDate, _placeholder$endTime;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start';
      var placeholders = {
        startTime: (_placeholder$startTim = placeholder === null || placeholder === void 0 ? void 0 : placeholder.startTime) !== null && _placeholder$startTim !== void 0 ? _placeholder$startTim : locale.startTime,
        startDate: (_placeholder$startDat = placeholder === null || placeholder === void 0 ? void 0 : placeholder.startDate) !== null && _placeholder$startDat !== void 0 ? _placeholder$startDat : locale.startDate,
        endDate: (_placeholder$endDate = placeholder === null || placeholder === void 0 ? void 0 : placeholder.endDate) !== null && _placeholder$endDate !== void 0 ? _placeholder$endDate : locale.endDate,
        endTime: (_placeholder$endTime = placeholder === null || placeholder === void 0 ? void 0 : placeholder.endTime) !== null && _placeholder$endTime !== void 0 ? _placeholder$endTime : locale.endTime
      };
      var _isTimePicker = isTimePicker();
      if (type === 'start') {
        return _isTimePicker ? placeholders.startTime : placeholders.startDate;
      }
      return _isTimePicker ? placeholders.endTime : placeholders.endDate;
    };
    return /*#__PURE__*/React.createElement(_PanelContext.default.Provider, {
      value: {
        operationRef: operationRef,
        hideHeader: picker === 'time',
        onDateMouseEnter: onDateMouseEnter,
        onDateMouseLeave: onDateMouseLeave,
        hideRanges: true,
        onSelect: onContextSelect,
        open: mergedOpen
      }
    }, /*#__PURE__*/React.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
      return /*#__PURE__*/React.createElement(_ModalContext.ModalContextConsumer, null, function (value) {
        return /*#__PURE__*/React.createElement(_PickerTrigger.default, {
          visible: mergedOpen,
          popupElement: rangePanel('ykb-ui-picker'),
          popupStyle: popupStyle,
          prefixCls: "ykb-ui-picker",
          dropdownClassName: dropdownClassName,
          dropdownAlign: dropdownAlign,
          getPopupContainer: value !== null && value !== void 0 && value.renderOnBody ? function () {
            return value.container;
          } : getPopupContainer,
          transitionName: transitionName,
          range: true,
          direction: direction
        }, /*#__PURE__*/React.createElement(_StyledDatePicker.StyledRangePicker, (0, _extends2.default)({
          theme: theme,
          ref: containerRef,
          $disabled: mergedDisabled[0] && mergedDisabled[1],
          $focused: mergedActivePickerIndex === 0 ? startFocused : endFocused,
          $size: size,
          style: style,
          className: (0, _classnames.default)(className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls), !!prefixCls), "".concat(prefixCls, "-range"), !!prefixCls), "".concat(prefixCls, "-disabled"), !!prefixCls && mergedDisabled[0] && mergedDisabled[1]), "".concat(prefixCls, "-focused"), !!prefixCls && mergedActivePickerIndex === 0 ? startFocused : endFocused), "".concat(prefixCls, "-rtl"), !!prefixCls && direction === 'rtl'))
        }, (0, _miscUtil.default)(props)), /*#__PURE__*/React.createElement(_StyledDatePicker.StyledDatePickerInput, {
          theme: theme,
          $active: mergedActivePickerIndex === 0,
          $size: size,
          ref: startInputDivRef,
          className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-input"), !!prefixCls), "".concat(prefixCls, "-input-active"), !!prefixCls && mergedActivePickerIndex === 0), "".concat(prefixCls, "-sm"), !!prefixCls && size == 'small'))
        }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
          inputRef: function inputRef(inputEl) {
            startInputRef.current = inputEl;
          },
          value: startInputDisplayValue,
          onChange: startDateInputChange,
          allowInputChange: allowInputChange,
          placeholder: getPlaceholder('start'),
          style: style,
          showSecond: showSecond,
          picker: picker,
          onClearClicked: onClearClicked,
          showTime: showTime,
          disabled: disabled,
          size: size,
          showSuffix: false,
          triggerOpen: _triggerOpen,
          className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "-datepicker-input"), true)),
          isPickerOpen: mergedOpen,
          autoComplete: autoComplete
        }, startInputProps, restProps))), /*#__PURE__*/React.createElement(_StyledDatePicker.StyledRangeSeparator, {
          className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-range-separator"), !!prefixCls)),
          theme: theme,
          ref: separatorRef
        }, /*#__PURE__*/React.createElement(_StyledDatePicker.StyledSwapIcon, {
          $theme: theme,
          name: "swap-right",
          size: 24
        })), /*#__PURE__*/React.createElement(_StyledDatePicker.StyledDatePickerInput, {
          theme: theme,
          $active: mergedActivePickerIndex === 1,
          $endInput: true,
          ref: endInputDivRef,
          className: (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-input"), !!prefixCls), "".concat(prefixCls, "-input-active"), !!prefixCls && mergedActivePickerIndex === 1), "".concat(prefixCls, "-sm"), !!prefixCls && size == 'small'))
        }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
          inputRef: function inputRef(inputEl) {
            endInputRef.current = inputEl;
          },
          value: endInputDisplayValue,
          onChange: endDateInputChange,
          allowInputChange: allowInputChange,
          allowClear: allowClear,
          placeholder: getPlaceholder('end'),
          style: style,
          showSecond: showSecond,
          picker: picker,
          onClearClicked: onClearClicked,
          showTime: showTime,
          disabled: disabled,
          size: size,
          triggerOpen: _triggerOpen,
          className: (0, _classnames.default)(className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "-datepicker-input"), true)),
          isPickerOpen: mergedOpen,
          autoComplete: autoComplete
        }, endInputProps, {
          // {...inputSharedProps}
          renderOnBody: value === null || value === void 0 ? void 0 : value.renderOnBody
        }))), /*#__PURE__*/React.createElement(_StyledDatePicker.StyledRangePickerActiveBar, {
          theme: theme,
          className: (0, _classnames.default)((0, _defineProperty2.default)({}, "".concat(prefixCls, "-active-bar"), !!prefixCls)),
          style: _objectSpread(_objectSpread({}, activeBarPositionStyle), {}, {
            width: activeBarWidth,
            position: 'absolute'
          })
        }), suffixIcon ? /*#__PURE__*/React.createElement(StyledPickerSuffix, {
          theme: theme
        }, suffixIcon) : null));
      });
    }));
  };
};
var _default = exports.default = RangePicker;